<template>
  <div>
    <div class="feedback"> <el-tooltip class="item" effect="dark" :content="$t('common.support')" placement="top-start">
      <i class="el-icon-service feedback-btn" @click="serviceVisible = true"></i>
    </el-tooltip></div>
    <div class="service" v-show="serviceVisible">
        <div class="clearfix title">
          <span class=" fl">Infotikx {{$t('common.support')}}</span>
          <i class="el-icon-close fr btn-icon" @click="serviceVisible = false"></i>
          <i class="el-icon-refresh-right fr btn-icon" @click="clearHistory()"></i>
        </div>
        <div class="content" id="serviceList">

          <li class="clearfix" v-for="(item,index) in history" :key='index'>
              <!-- 系统发送的消息 -->
              <div v-if="item.sender === 's' && item.type === 't'" class=" system">{{item.content}}</div>
              <!-- 用户发送的消息 -->
              <div v-else-if="item.sender === 'u' && item.type === 't'" class="fr user">{{item.content}}</div>
              <!-- 文章 -->
              <div v-else-if="item.sender === 's' && item.type === 'a'" class="article">
                <div class="article">
                  <div class="article-list">
                      <div @click="isShowId=item.id"><span style="font-weight: 700;">{{item.title}}</span></div>
                      <div v-if='isShowId == item.id' v-html='item.content' style="margin-top: 10px;"></div>
                      <!-- <router-link v-if='isShowId == item.id' :to='item.url'>查看内容</router-link> -->
                      <el-button v-if='isShowId == item.id' type="text" @click="toReadArticle(item.id)">{{$t('common.readArticle')}}</el-button>
                  </div>
                </div>
              </div>
          </li>
          <li v-show="loadingFlag">
            <div class="spinner system">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </li>
          <li class="">
              <!-- 选项 -->
              <div class="choose clearfix" v-if="chooseList.length > 0">
                <div class="choose-type fl" v-for="(item,index) in chooseList" :key="index" @click="choose(item)">{{item.content}}</div>
              </div>
              <!-- 发送问题 -->
              <div class="seed-question" v-if="startSearch">
                  <div>{{$t('common.sendKeywordTip')}}</div>
                  <el-input
                    type="textarea"
                    :placeholder="$t('msg.chatTip')"
                    v-model="inputKeyword"
                    maxlength="200"
                    :rows="6"
                    show-word-limit
                    class="textarea"
                    style="100px"
                  >
                  </el-input>
                  <el-button class="seed-btn" type="primary" :disabled="hasText" @click="getCommonProblemByUserInputKeyword(inputKeyword)">{{$t('msg.send')}}</el-button>
              </div>
              <!-- 反馈 -->
              <div class="seed-message" v-if="feedback">
                <el-form ref="feedbackForm" :model="feedbackForm" label-width="80px">
                  <!-- <el-form-item label="Name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item> -->
                  <el-form-item
                    prop="contact"
                    :label="$t('common.email')"
                    :rules="[
                      { required: true, message: this.$t('signUp.enterEmailTip'), trigger: 'blur' },
                      { type: 'email', message: this.$t('signUp.emailErrorTip'), trigger: 'blur'}
                    ]">
                    <el-input v-model="feedbackForm.contact"></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="content"
                    :label="$t('common.inputContentTip')"
                    :rules="[
                      { required: true, message: this.$t('common.inputContentTip'), trigger: 'blur' },
                    ]">
                    <el-input :rows="6" maxlength="500" type="textarea" v-model="feedbackForm.content"></el-input>
                  </el-form-item>
                  <el-button class="seed-btn" type="primary" @click="postFeedback()">{{$t('msg.send')}}</el-button>
                </el-form>
              </div>
              <!-- 在线客服 -->
              <div class="seed-onlineService" v-if="isShowChatInput">
                <el-input
                  type="textarea"
                  @keyup.enter.native='sendMsg()'
                  v-model="msgSendDto.content"
                  maxlength="500"
                  :rows="6"
                  show-word-limit
                  class="textarea"
                  style="100px"
                >
                </el-input>
                <el-button class="seed-btn" type="primary" @click="sendMsg()">{{$t('msg.send')}}</el-button>
              </div>
          </li>
        </div>
    </div>
  </div>
</template>
<script>
import { getByParentId, getCommonProblemByKeyword } from "@/api/autoQAndA";
import { checkKefuExist } from "@/api/onlineSer";
import { postFeedback } from "@/api/feedback";
export default {
  name: "customerService",
  computed: {
    hasText() {
      if (this.inputKeyword != null && this.inputKeyword.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      wsUrl: this.COMMON.wsUrl,
      lang: this.$i18n.locale,
      serviceVisible: false,
      inputKeyword: null,
      feedbackForm: {
        // name: "",
        contact: "",
        content: ""
      },
      history: [], //历史记录
      isShowId: null, // 当前展示的文章相亲索引
      chooseList: [],
      choosingItem: null,
      startSearch: false,
      feedback: false,
      loadingFlag: false,
      ws: null,
      userId: null,
      isShowChatInput: false,
      msgSendDto: {
        chatId: null,
        type: 't',
        sendTime: null,
        senderName: null,
        senderId: null,
        senderAvatar: null,
        content: null
      },
      userId: this.$store.state.id,
    };
  },
  created() {
    console.log(this.userId)
    this.getByParentId(this.userId ? "4-4" : "0");
  },
  methods: {
    choose(item) {
      this.chooseList = [];
      this.choosingItem = item;
      let msg = {
        id: item.id,
        sender: "u",
        type: "t",
        content: item.content
      };
      this.history.push(msg);
      if (item.nextId) {
        this.getByParentId(item.nextId);
      } else {
        this.getByParentId(item.id);
      }
    },
    getByParentId(parentId) {
      this.loadingFlag = true;
      let that = this;
      getByParentId(parentId).then(res => {
        let time = 1000 + Math.random()*1500;
        if (res.code == 0) {
          setTimeout(function() {
            that.loadingFlag = false;
            res.data.forEach(item => {
              if (item.type === "t") {
                // 添加对话历史
                let msg = {
                  id: item.id,
                  sender: "s",
                  type: item.type,
                  content: that.lang === "zh" ? item.contentZh : item.contentEn
                };
                that.history.push(msg);
              } else if (item.type === "o") {
                // 添加选择
                let o = {
                  id: item.id,
                  type: item.type,
                  content: that.lang === "zh" ? item.contentZh : item.contentEn,
                  nextId: item.nextId
                };
                that.chooseList.push(o);
              } else if (item.type === "e") {
                // 事件
                if (item.eventCode === "TO_LOGIN") {
                  // 登录
                  let routerJump = that.$router.resolve({ path: `/login` });
                  window.open(routerJump.href, "_blank");
                } else if (item.eventCode === "TO_SIGN_UP") {
                  // 注册
                  let routerJump = that.$router.resolve({ path: `/register` });
                  window.open(routerJump.href, "_blank");
                } else if (item.eventCode === "SEARCH_BY_PARENT_CONTENT") {
                  // 根据上级内容搜索
                  that.getCommonProblemByKeyword(that.choosingItem.content);
                  that.choosingItem = item;
                } else if (item.eventCode === "START_SEARCH") {
                  // 开启搜索文章输入框
                  that.startSearch = true;
                  that.choosingItem = item;
                } else if (item.eventCode === "FEEDBACK") {
                  // 开启反馈提交
                  that.feedback = true;
                  that.choosingItem = item;
                } else if (item.eventCode === "ONLINE_SERVICE") {
                  // 联系客服
                  // that.initWebSocket();
                  that.checkKefuExist();
                  that.choosingItem = item;
                }
              }
            });
            that.scrollToBottom();
          }, time);
        }
      });
    },
    // 顶部刷新按钮
    clearHistory() {
      // 清空历史信息，问答初始化待添加
      this.closeWebSocket();
      this.isShowChatInput = false;
      this.msgSendDto.content = null;
      this.history = [];
      this.chooseList = [];
      this.choosingItem = null;
      this.startSearch = false;
      this.inputKeyword = null;
      this.loadingFlag = false;
      this.feedback = false;
      this.feedbackForm = {
        contact: "",
        content: ""
      },
      this.getByParentId("4-4");
    },
    // 根据关键字查询文章
    getCommonProblemByKeyword(keyword) {
      let that = this;
      this.loadingFlag = true;
      let dto = {
        lang: this.lang,
        keyword: keyword
      };
      getCommonProblemByKeyword(dto).then(res => {
        let time = 1000 + Math.random() * 1500;
        if (res.code === 0) {
          setTimeout(function() {
            that.loadingFlag = false;
            if (res.data.length > 0) {
              // 有相关文章
              let msg = {
                id: null,
                sender: "s",
                type: "t",
                content: that.lang === "zh" ? "这是我找到的" : "Here's what I found"
              };
              that.history.push(msg);
              // 处理找到的文章
              that.isShowId = res.data[0].id;
              res.data.forEach(item => {
                let msg = {
                  id: item.id,
                  sender: "s",
                  type: "a",
                  title: item.title,
                  content: item.content
                };
                that.history.push(msg);
              });
            } else {
              // 无相关文章
              let msg = {
                id: null,
                sender: "s",
                type: "t",
                content: that.lang === "zh" ? "没有找到相关内容": "Hm, we couldn't find anything."
              };
              that.history.push(msg);
              let msg2 = {
                id: null,
                sender: "s",
                type: "t",
                content: that.lang === "zh" ? "您可以联系我们，电话：86-20-37616606 电子邮箱：info@infotikx.com": "You can contact us at 86-20-37616606 or email: info@infotikx.com"
              };
              that.history.push(msg2);
            }
            if (that.choosingItem != null && that.choosingItem.nextId) {
              that.getByParentId(that.choosingItem.nextId);
            } else {
              that.getByParentId(that.choosingItem.id);
            }
            that.scrollToBottom();
          }, time);
        }
      });
    },
    // 根据用户输入的关键字查询相关文章
    getCommonProblemByUserInputKeyword(keyword) {
      this.inputKeyword = null;
      this.startSearch = false;
      let msg = {
        id: null,
        sender: "u",
        type: "t",
        content: keyword.trim()
      };
      this.history.push(msg);
      this.getCommonProblemByKeyword(keyword.trim());
      this.scrollToBottom();
    },
    // 前往阅读文章
    toReadArticle(id) {
      let routerJump = this.$router.resolve({
        path: `/help/article`,
        query: { pid: id }
      });
      window.open(routerJump.href, "_blank");
    },
    // 提交反馈信息
    postFeedback() {
      this.$refs[`feedbackForm`].validate(valid => {
        if (valid) {
          let msg = {
            id: null,
            sender: "u",
            type: "t",
            content: this.feedbackForm.content.trim()
          };
          this.history.push(msg);
          this.feedback = false;
          postFeedback(this.feedbackForm).then(res => {
            if (res.code == 0) {
              this.getByParentId(this.choosingItem.id);
            }
          })
        } else {
          this.isSavingProject = false;
          return false;
        }
      })
    },
    //滚动至底部
    scrollToBottom() {
      this.$nextTick(() => {
        var container = this.$el.querySelector("#serviceList");
        container.scrollTop = container.scrollHeight;
      });
    },
    checkKefuExist() {
      checkKefuExist().then(res => {
        if (res.data) {
          this.initWebSocket();
        } else {
          // let msg = {
          //   id: null,
          //   sender: "s",
          //   type: 't',
          //   content: this.lang === "zh" ? '客服忙, 请稍后再试' : 'Customer service is busy, please try again later'
          // };
          // this.history.push(msg);
          if (this.choosingItem != null && this.choosingItem.nextId) {
            this.getByParentId(this.choosingItem.nextId);
          } else {
            this.getByParentId(this.choosingItem.id);
          }
        }
      })
    },
    // 初始化websocket连接
    initWebSocket() {
      let that = this;
      let token = null;
      if (this.$store.state.id) {
        // 已登录
        this.userId = this.$store.state.id;
        token = this.$store.state.token;
        this.msgSendDto.senderName = that.$store.state.account;
      } else {
        // 未登录, 随机生成userId和token
        let onlineServiceUserData = JSON.parse(sessionStorage.getItem('onlineServiceUserData'));
        if (onlineServiceUserData) {
          this.userId = onlineServiceUserData.userId;
          token = onlineServiceUserData.token;
        } else {
          this.userId = Math.random().toString(36).slice(-6);
          token = this.userId + Math.round(new Date()) + Math.random().toString(36).slice(-6);
          let onlineServiceUserData = {
            userId: this.userId,
            token: token
          }
          sessionStorage.setItem('onlineServiceUserData', JSON.stringify(onlineServiceUserData));
        }
        this.msgSendDto.senderName = '游客-' + this.userId;
      }
      let url = this.wsUrl + "webSocketB/" + this.userId + "?Oauth-Token=" + token;
      this.ws = new WebSocket(url)
      this.ws.onopen = function(e) {
        that.isShowChatInput = true;
        that.msgSendDto.chatId = that.userId;
        that.msgSendDto.senderId = that.userId;
        console.log("服务器连接成功: " + url)
      };
      this.ws.onclose = function(e) {
        console.log("服务器连接关闭: " + url)
      };
      this.ws.onerror = function(e) {
        console.log("服务器连接出错: " + url)
      };
      this.ws.onmessage = function(e) {
        //接收服务器返回的数据
        let resData = JSON.parse(e.data)
        if(resData.content) {
          let msg = {
            id: resData.msgId,
            sender: resData.senderId == that.userId? 'u': 's',
            type: "t",
            content: resData.content
          };
          that.history.push(msg);
          that.scrollToBottom();
        }
      };
    },
    // 发送消息
    sendMsg() {
      if (!this.msgSendDto.content || this.msgSendDto.content.trim() == '') {
          this.$message({message: this.$t('msg.sendMsgTip'), type: 'warning', showClose: true});
          this.msgSendDto.content = null;
          return;
      }
      let msgDto = JSON.parse(JSON.stringify(this.msgSendDto));
      this.ws.send(JSON.stringify(msgDto));
      this.msgSendDto.content = null;
    },
    // 断开webSocket连接
    closeWebSocket() {
      if (this.ws != null) {
        this.ws.close();
      }
    }
  }
};
</script>


<style scoped>
@media screen and (max-width: 996px) {
  .service{
    width: 90%!important;
    left: 5%!important;
    right: 5%!important;
  }
  .content{
    width: auto!important;
  }
}
.article-list {
  text-align: left;
  background-color: rgb(255, 255, 255);
  border: 2px solid rgba(0, 0, 0, 0.1);
  padding: 7%;
  box-shadow: rgb(0 0 0 / 5%) 0px 2px 4px;
  border-radius: 20px;
  margin-bottom: 15px;
  cursor: pointer;
}
.seed-btn {
  width: 100%;
}
.textarea {
  margin: 10px 0;
}
.seed-onlineService {
  padding: 7px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  line-height: 20px;
  margin-bottom: 15px;
  /* bottom: 0;
  position: absolute;
  width: calc(100% - 36px); */
}
.seed-message {
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  line-height: 20px;
  margin-bottom: 15px;
}
.choose {
  padding: 10px;
  margin-bottom: 15px;
}
.choose-type {
  margin-right: 10px;
  /* line-height: 36px; */
  padding: 8px 14px;
  border: 1px solid rgb(55, 58, 77);
  border-radius: 18px;
  margin-bottom: 10px;
}
.choose-type:hover {
  border-color: #135bff;
  background: #135bff;
  color: #fff;
  cursor: pointer;
}
.content {
  vertical-align: bottom;
  overflow: auto;
  height: calc(70vh - 90px);
  padding: 20px 10px 0;
  width: 360px;
}
.system {
  position: relative;
  padding: 9px 12px;
  background-color: rgb(242, 244, 247);
  border-radius: 2px 10px 10px;
  margin: 0px 15% 16px 40px;
  width: fit-content;
  max-width: 236px;
  min-height: 22px;
}
.system::before {
  content: "";
  width: 32px;
  height: 32px;
  display: block;
  position: absolute;
  left: -40px;
  top: 0px;
  border-radius: 50%;
  background-color: var(--theme);
  background-image: url("~@/assets/img/footerLogin.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.user {
  position: relative;
  padding: 9px 12px;
  background-color: #135bff;
  border-radius: 10px 2px 10px 10px;
  margin-right: 0px;
  margin-left: 25%;
  align-self: flex-end;
  margin-bottom: 16px;
  word-break: break-word;
  width: fit-content;
  max-width: 236px;
  color: #fff;
}
.title {
  height: 56px;
  line-height: 56px;
  background: #135bff;
  font-size: 14px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #ffffff;
  padding-left: 80px;
}
.btn-icon {
  line-height: 56px;
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
}
.btn-icon:hover {
  opacity: 0.8;
}
.feedback-btn {
  color: #0e1724;
  display: block;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
}
.feedback {
  background-color: #fff;
  position: fixed;
  right: 40px;
  bottom: 250px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  z-index: 5;
}
.service {
  height: 70vh;
  width: 380px;
  position: fixed;
  right: 100px;
  top: 15vh;
  background: #ffffff;
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  border-radius: 10px;
  z-index: 800;
}

.feedback-btn:hover {
  color: #135bff;
}
li {
  text-decoration: none;
  list-style: none;
}
div /deep/ .el-form-item__label {
  display: block;
  float: none;
  width: 100% !important;
  text-align: left;
}
div /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.spinner {
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 10px;
  height: 10px;
  background-color: #135bff;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customerService/customerService.vue